export const EMPTY_ALL = 'EMPTY_ALL'
export const INIT = 'INIT'
export const SET_ANO_SELECTED= 'SET_ANO_SELECTED'
export const SET_ANOS = 'SET_ANOS'
export const SET_MES_SELECTED = 'SET_MES_SELECTED'
export const SET_MESES = 'SET_MESES'
export const SET_USER = 'SET_USER'
export const SET_CENTRO_CUSTO = 'SET_CENTRO_CUSTO '
export const SET_COMPETENCIA_LIST= 'SET_COMPETENCIA_LIST'
export const SET_CENTRO_CUSTO_LIST = 'SET_CENTRO_CUSTO_LIST'
export const SET_COMPETENCIA_OPEN = 'SET_COMPETENCIA_OPEN'
export const SET_COMPETENCIA_SELECTED = 'SET_COMPETENCIA_SELECTED'
export const SET_CENTRO_CUSTO_SELECTED = 'SET_CENTRO_CUSTO_SELECTED'
export const SET_PERIODO_SELECTED = 'SET_PERIODO_SELECTED'
export const SET_FILTER_UPDATE_AT = 'SET_FILTER_UPDATE_AT'
export const SET_USER_LIST = 'SET_USER_LIST'
export const SET_ARVORE_LIST = 'SET_ARVORE_LIST'
export const SET_PERIODO_LIST = 'SET_PERIODO_LIST'
export const SET_REDIRECT = 'SET_REDIRECT'
export const SET_PROCESSO_LIST = 'SET_PROCESSO_LIST'
export const SET_INDICADOR_LIST = 'SET_INDICADOR_LIST'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js